export default [
  {
    title: `Sobre a H Cred`,
    text: `Crédito de maneira rápida e inteligente. Há mais de 10 anos no mercado. Especializados em empréstimos no cartão de crédito.`,
  },
  {
    title: `O que é o empréstimo no cartão de crédito?`,
    text: `Essa modalidade funciona como um empréstimo pessoal convencional, sendo uma linha de crédito relacionada ao seu cartão sem comprometer o limite disponível. Você pode antecipar o recebimento de valores futuros, ou seja, adiantar parte do limite do seu cartão de crédito e realizar o pagamento posteriormente.`,
  },
  {
    title: `Quais são as etapas de solicitação da oferta pré-aprovada?`,
    text: `
    Após selecionar a sua oferta em nossa plataforma, você será direcionado para o nosso time de atendimento para dar continuidade à contratação:
    <ol>
      <li>Informe seus dados bancários ao nosso time de atendimento.</li>
      <li>Realização de simulação e escolha dos valores/parcelas.</li>
      <li>Envie a foto do seu cartão de crédito (não é necessário o código de segurança) e documentos de identificação: RG, CNH, RNE e Carteira de Classe.</li>
      <li>Faça a assinatura com a selfie segurando o cartão em mãos.</li>
      <li>Aguarde a análise.</li>
      <li>Aprovação do empréstimo e depósito em até 30 minutos na sua conta.</li>
    </ol>
    `,
  },
  {
    title: `Qual a documentação necessária para contratar? `,
    text: `
      São necessários apenas dois documentos para prosseguir com a oferta:
      <ul>
        <li>Documento de Identidade.</li>
        <li>Foto do cartão de crédito frente e verso (não é necessário o código de segurança).</li>
        <li>Selfie com o cartão</li>
      </ul>
    `,
  },
  {
    title: `Quais são os requisitos para pedir um empréstimo?`,
    text: `
      Os requisitos para pedir um empréstimo são:
      <ul>
        <li>Ter idade acima de 18 anos.</li>
        <li>Possuir um cartão de crédito (VISA, MASTER, ELO, AMEX, SOROCRED ou HIPERCARD).</li>
        <li>SSer o titular do cartão de crédito.</li>
      </ul>
    `,
  },
]
